import { BoxProps, Text } from "@chakra-ui/react";

import { NavItem } from "./config";

import { Link } from "ui";

export const navItemStyles: BoxProps = {
  cursor: "pointer",
  userSelect: "none",
  fontSize: "md",
  fontWeight: "normal",
  width: "100%",
  py: 1,
  _focus: {
    outline: "none !important",
  },
  _focusVisible: {
    outline: "none",
    boxShadow: "outline",
  },
};

type NavLinkProps = {
  item: NavItem;
  isActive: boolean;
  path: string;
  subNavLeftPadding: number;
  toggle?: () => void;
};

export function NavLink({
  item,
  isActive,
  path,
  subNavLeftPadding,
  toggle,
}: NavLinkProps) {
  return (
    <Link
      href={item.href ?? path}
      display="flex"
      alignItems="center"
      minHeight={{ base: "44px", md: "32px" }}
      pl={subNavLeftPadding}
      pr={2}
      borderRadius="lg"
      fontSize="md"
      fontWeight="normal"
      color={isActive ? "primary.pressed" : "text.secondary"}
      bg={isActive ? "primary.background" : "transparent"}
      transition="background-color 150ms ease-out, color 150ms ease-out"
      sx={{ touchAction: "manipulation" }}
      outline="none"
      _focusVisible={{ boxShadow: "outline" }}
      _hover={
        isActive ? undefined : { bg: "base.background", color: "text.primary" }
      }
      onClick={toggle}
    >
      <Text as="span" lineHeight="20px">
        {item.label}
      </Text>
    </Link>
  );
}
